import { ReactNode } from 'react';

export const mapConfigToOptions = (
  constants: Record<
    string,
    { label: ReactNode; icon?: ReactNode; text?: string }
  >,
  configOptions?: Record<string, string | number>[],
  keysMap?: { id?: string; name?: string },
) =>
  configOptions?.map((configOption) => {
    const id = keysMap?.id
      ? configOption[keysMap.id]
      : configOption.id;
    const name = keysMap?.name
      ? configOption[keysMap.name]
      : configOption.name;
    const constantsIdx =
      typeof name === 'string' ? name.toLowerCase() : name;

    return {
      id: id || name,
      value: id || name,
      label: constants[constantsIdx]?.label || name,
      text: constants[constantsIdx]?.text || name,
      icon: constants[constantsIdx]?.icon,
    };
  }) || [];

export const mapConstantsToOptions = (
  constants: Record<string, { label: ReactNode; icon?: ReactNode }>,
) =>
  Object.entries(constants).map(([key, { label, icon }]) => ({
    id: key,
    value: key,
    label,
    icon,
  }));

export const sortOptions = (
  options: {
    id: string | number;
    value: string | number;
    label: ReactNode;
    icon: ReactNode;
  }[],
) =>
  options.sort((a, b) =>
    typeof a.value === 'string' && typeof b.value === 'string'
      ? a.value.localeCompare(b.value)
      : Number(b.value) - Number(a.value),
  );
